var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSortDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.09 19.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000032;stroke-miterlimit:10;}.cls-2{fill:#000032;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sort_Down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rswAgG.tif"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.65,4.06l-.24.22C3.71,5,3,5.71,2.29,6.41A1,1,0,0,1,.55,6,1,1,0,0,1,.8,5Q2.87,2.87,5,.8A1,1,0,0,1,6.4.81l4.12,4.11A1,1,0,0,1,9.05,6.37C8.34,5.67,7.64,5,6.94,4.26l-.22-.21V18a1,1,0,1,1-2.07,0v-14Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.93,15.6v-14a1,1,0,1,1,2.07,0v14l.22-.2,2.07-2.05a1,1,0,1,1,1.44,1.47l-4,4a1,1,0,0,1-1.59,0l-4-4a1,1,0,0,1,0-1.51,1,1,0,0,1,1.5.05l2.05,2.06Z",
    transform: "translate(0 0)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDown);
export default __webpack_public_path__ + "static/media/Sort_Down.71e68ac93d5e9d1b89db0c8d6a4a0c9c.svg";
export { ForwardRef as ReactComponent };